export enum RoleToEnum {
    Adm_TAG = 'ADMIN',
    Prod_TAG = 'MAKER',
    Lab_TAG = '',
    Sel_TAG = 'SELLER',
    Dis_TAG = 'DISTRIBUTOR'
}

